import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fd82fdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "js-loading-section l-loading" }
const _hoisted_2 = { class: "loading__tl" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linear-activity" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indeterminate" })
], -1))
const _hoisted_4 = { class: "loading__dc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('loading.title')), 1),
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('loading.text')), 1)
  ]))
}